import { createContext, useMemo, useReducer, useState } from "react"

export const LayoutContext = createContext(null);

const jumpSectionDataDefaultState = {
  maxWidth: 510,
  links: null,
}

function LayoutContextContainer({children}) {
  /* Use for refreshing the cookie police component state, and other layiout elements */
  const [cookieStored, setCookieStored] = useState(false);
  /* Show/Hides mobile menu state */
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  /* Tooltip */
  const [currentTooltip, setCurrentTooltip] = useState(undefined);
  /* hcp subnav state */
  const [hcpSubnavState, setHcpSubnavState] = useState(false);
  /* modal */
  const [modalState, setModalState] = useState(false);
  const [modalButtonUrl, setModalButtonUrl] = useState('');
  const [modalTargetBlank, setModalTargetBlank] = useState(true);
  /* sticky header state */
  const [stickyHeaderFixedState, setStickyHeaderFixedState] = useState(false);
  /* captcha key */
  const captchaKey = useMemo(() => {
    const key = process.env.REACT_APP_HOSTING_ENVIRONMENT === "PRODUCTION"
      ? process.env.REACT_APP_RECAPTCHA_KEY_PRODUCTION
      : process.env.REACT_APP_RECAPTCHA_KEY_STAGING;
    return key;
  }, []);
  /* jump section data */
  const [jumpSectionData, dispatchJumpSectionData] = useReducer((state, {type, maxWidth, links, ...rest}) => {
    switch (type) {
      case 'SET_DATA':
        return { ...state, maxWidth, links, ...rest };
      case 'SET_MAX_WIDTH':
        return { ...state, maxWidth, };
      case 'SET_LINKS':
        return { ...state, links, };
      case 'SET_REST':
        return { ...state, ...rest };
      case 'SET_RESET':
        return jumpSectionDataDefaultState;
      default:
        return state;
    }
  }, jumpSectionDataDefaultState);
  /* auto scroll active state: used by PageAnchor and PatientJumpToSection to help with smooth scrolling */
  const [autoScrollActive, setAutoScrollActive] = useState(false);
  /* find doctor search data */
  const [findDoctorSearchData, setFindDoctorSearchData] = useState(null);
  /* webp support */
  const supportsWebP = useMemo(() => {
    const canvas = document.createElement('canvas');
    if (!!(canvas.getContext && canvas.getContext('2d'))) {
      return canvas.toDataURL('image/webp').indexOf('data:image/webp') === 0;
    }
    return false;
  }, []);

  const provider = useMemo(() => {
    function setCookieConsent() {
      const name = 'NeurocrineDSE=Consent;';
      const expDays = 30;
      const date = new Date();

      date.setTime(date.getTime() + (expDays * 24 * 60 * 60 * 1000));
      const expires = `expires=${date.toUTCString()};`;

      // deepcode ignore WebCookieSecureDisabledByDefault: It's being applied in the string
      document.cookie = `${name}${expires}path=/;Secure;SameSite=Strict;`;
    }

    function cookieConsent() {
      let name = "NeurocrineDSE=";
      let decodedCookie = decodeURIComponent(document.cookie);
      let ca = decodedCookie.split(';');

      for(let i = 0; i <ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    }

    function getAgeRange(){
      if (sessionStorage.ageRange) {
        return sessionStorage.ageRange;
      }
      return null;
    }

    function setAgeRange(val){
      sessionStorage.ageRange =  val;
    }

    return {
      cookieConsent,
      setCookieConsent,
      cookieStored,
      setCookieStored,
      showMobileMenu,
      setShowMobileMenu,
      currentTooltip,
      setCurrentTooltip,
      hcpSubnavState,
      setHcpSubnavState,
      getAgeRange,
      setAgeRange,
      modalState,
      setModalState,
      modalButtonUrl,
      setModalButtonUrl,
      modalTargetBlank,
      setModalTargetBlank,
      stickyHeaderFixedState,
      setStickyHeaderFixedState,
      jumpSectionData,
      dispatchJumpSectionData,
      autoScrollActive,
      setAutoScrollActive,
      findDoctorSearchData,
      setFindDoctorSearchData,
      captchaKey,
      supportsWebP,
    }}, [
      cookieStored,
      showMobileMenu,
      currentTooltip,
      hcpSubnavState,
      modalState,
      modalButtonUrl,
      modalTargetBlank,
      stickyHeaderFixedState,
      jumpSectionData,
      autoScrollActive,
      findDoctorSearchData,
      captchaKey,
      supportsWebP
    ]
  );

  return (
    <>
      <LayoutContext.Provider value={provider}>
        {children}
      </LayoutContext.Provider>
    </>
  )
}

export default LayoutContextContainer;